import React from 'react';

import { Flex, Grid, GridItem, useTheme } from '@chakra-ui/react';
import useOrganisationSettings from 'components/hooks/useOrganisationSettings';

import { InfoWorkZero } from 'assets/assetsV1/iconComponents';

import { OKR_PROGRESS_TYPES } from 'constants/ProjectConstants';
import { isMobileView } from 'constants/isMobileView';

import { Tooltip } from 'uiToolkitV1/Tooltip';

import { OKRTargetValue } from '../Overview/OKRTargetValue';
import OKRMeasure from './OKRMeasure';
import { OKRMetric } from './OKRMetric';
import { OKRStartValue } from './OKRStartValue';

export const InputLabelTextWithInfoTooltip = React.memo(({ labelText }) => {
  const theme = useTheme();
  const { moduleName, objectivesName, keyResultsName } = useOrganisationSettings();
  const tooltipText = `Measure/Metrics for all children should be same when parent is set as "Dependant - Sum". If you still want to proceed with action please update parent ${moduleName} to "Dependant- Average"`;
  return (
    <Tooltip fontSize="14px" label={tooltipText}>
      <Flex>
        {labelText}
        <InfoWorkZero style={{ marginLeft: '5px' }} boxSize="18px" color={theme.colors.neutral['666666']} />
      </Flex>
    </Tooltip>
  );
});

export const ManualKRTracking = ({
  startingProgressValue,
  target,
  measureType,
  measure,
  onChange,
  isReadOnly,
  parentProgressType,
}) => {
  const isParentProgressTypeDerivedSum = parentProgressType === OKR_PROGRESS_TYPES.DERIVED_SUM;
  const showInfoTooltip = !isReadOnly && isParentProgressTypeDerivedSum;

  return (
    <>
      <Grid gridTemplateColumns={isMobileView() ? '45% 45%' : '40% 33%'} justifyContent="space-between">
        <GridItem>
          <OKRStartValue
            startValue={startingProgressValue}
            onChange={(startingProgressValue) => onChange({ startingProgressValue })}
            isReadOnly={isReadOnly}
          />
        </GridItem>
        <GridItem>
          <OKRTargetValue target={target} onChange={(target) => onChange({ target })} isReadOnly={isReadOnly} />
        </GridItem>
      </Grid>
      <Flex direction="column">
        <OKRMetric
          measureType={measureType}
          onChange={(measureType) => onChange({ measureType })}
          isReadOnly={isReadOnly || isParentProgressTypeDerivedSum}
          showInfoTooltip={showInfoTooltip}
          showTextTooltip
        />

        <OKRMeasure
          measure={measure}
          onChange={(measure) => onChange({ measure })}
          isReadOnly={isReadOnly || isParentProgressTypeDerivedSum}
          showInfoTooltip={showInfoTooltip}
        />
      </Flex>
    </>
  );
};
